var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool2Imageeffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_20083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.835 11.8398L13.605 13.6198",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5149 17.48H13.0249",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4849 10.52V13.03",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.595 23.3303L14.375 21.5503",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6851 14.2602L23.4651 12.4902",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9127 20.4262L20.4277 21.9111L28.0362 29.5196L29.5211 28.0347L21.9127 20.4262Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 15.7783L15.791 17.2632L18.1952 19.6673L19.6801 18.1824L17.2759 15.7783Z",
    fill: "current",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_20083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.97,
    height: 19.96,
    fill: "current",
    transform: "translate(10.0149 10.02)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool2Imageeffect);
export default __webpack_public_path__ + "static/media/tool2_image effect.70686084c0878561fbff277eefe40fcd.svg";
export { ForwardRef as ReactComponent };